export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/photographic.7213a8f.svg";